export default {
  hightlightedLocationFilterWarning: {
    id: 'ADVANCED_EARNED_SEARCH_HIGHTLIGHTED_LOCATION_FILTER_WARNING',
    defaultMessage:
      'The location filter has been disabled. You can adjust within the search or contact customer support for help.',
    description:
      'Advanced earned search page on new Searches, the query already contains tk_location filter',
  },
  hightlightedLanguageFilterWarning: {
    id: 'ADVANCED_EARNED_SEARCH_HIGHTLIGHTED_LANGUAGE_FILTER_WARNING',
    defaultMessage:
      'The language filter has been disabled. You can adjust within the search or contact customer support for help.',
    description:
      'Advanced earned search page on new Searches, the query already contains tk_language filter',
  },
  newSearchTitleBarCaption: {
    id: 'ADVANCED_EARNED_SEARCH_NEW_SEARCH_TITLE_BAR_CAPTION',
    defaultMessage: 'New Search',
    description:
      'Title bar caption for the advanced earned search page on new Searches',
  },
  editSearchTitleBarCaption: {
    id: 'ADVANCED_EARNED_SEARCH_EDIT_SEARCH_TITLE_BAR_CAPTION',
    defaultMessage: 'Edit Search',
    description:
      'Title bar caption for the advanced earned search page to Edit Searches',
  },
  emptyStateCaption: {
    id: 'ADVANCED_EARNED_SEARCH_EMPTY_STATE_CAPTION',
    defaultMessage: 'Your results will show up here',
    description: 'Empty state caption on the  advanced earned search page',
  },
  getSearchDataError: {
    id: 'EARNED_SEARCHES_BASIC_OR_ADVANCE_GETTING_SEARCH_DATA_ERROR',
    defaultMessage:
      "An error occurred when trying to retrieve the search's data",
    description:
      'Text to show when the application is not able to retrieve the search data',
  },
  successfullySavedMessage: {
    id: 'EARNED_SEARCHES_SUCCESSFULLY_SAVED_SEARCH_MESSAGE',
    defaultMessage: 'All set! Your search has been saved.',
    description: 'text that shows after a search has been saved correctly',
  },
  failUpdateSearchMessage: {
    id: 'EARNED_SEARCHES_FAIL_UPDATE_SEARCH_MESSAGE',
    defaultMessage: 'An error occurred while trying to update your search.',
    description: 'text that shows after a search update has failed',
  },
  failCreateSearchMessage: {
    id: 'EARNED_SEARCHES_FAIL_CREATE_SEARCH_MESSAGE',
    defaultMessage: 'An error occurred while trying to create your search.',
    description: 'text that shows after a search creation has failed',
  },
  failPreviewSearchMessage: {
    id: 'EARNED_SEARCHES_FAIL_PREVIEW_SEARCH_MESSAGE',
    defaultMessage: 'Could not preview search. Query string is invalid.',
    description: 'text that shows after a search preview has failed',
  },
  getSubscriptionError: {
    id: 'EARNED_SEARCHES_GET_SUBSCRIPTION_ERROR',
    defaultMessage:
      'An error occurred when trying to retrieve the spike alert subscription Info',
    description:
      'Text to show when the application is not able to retrieve the subscription data',
  },
  subscribedSuccessfully: {
    id: 'EARNED_SEARCHES_SUCCESSFULLY_SUBSCRIBED',
    defaultMessage: 'Subscribed Successfully',
    description: 'Text to show when the spike alert subscription is successful',
  },
  subscribedError: {
    id: 'EARNED_SEARCHES_SUBSCRIBED_ERROR',
    defaultMessage:
      'An error occurred when trying to Subscribe to spike alerts for this search',
    description:
      'Text to show when the application is not able to create the spike alert subscription',
  },
  unsubscribedSuccessfully: {
    id: 'EARNED_SEARCHES_SUCCESSFULLY_UNSUBSCRIBED',
    defaultMessage: 'Unsubscribed Successfully',
    description: 'Text to show when unsubscribe to spike alert is successful',
  },
  unsubscribedError: {
    id: 'EARNED_SEARCHES_UNSUBSCRIBED_ERROR',
    defaultMessage:
      'An error occurred when trying to unsubscribe to spike alerts for this search',
    description:
      'Text to show when the application is not able to cancel this subscription',
  },
  createImpactSearchSuccessMessage: {
    id: 'EARNED_SEARCHES_CREATE_IMPACT_REPORT_SUCCESS',
    defaultMessage: 'search was added to Earned Impact Report',
    description:
      'Success messages indicating that the search added as impact text notification',
  },
  unableToCreateImpactSearch: {
    id: 'EARNED_SEARCHES_UNABLE_TO_CREATE_ERROR',
    defaultMessage: 'Search was unable to be saved as Earned Impact Report',
    description:
      'Error to display when the search cannot be saved for an unknown reason',
  },
  savedSearchPreviouslyRemoved: {
    id: 'EARNED_SEARCHES_REMOVED_SEARCH_ERROR',
    defaultMessage:
      'This search has been previously removed from Impact, please create a new search to save as Earned Impact.',
    description:
      'Error to display when a search has been previously removed from impact notification text',
  },

  earnedSearchSyncSuccess: {
    id: 'EARNED_SEARCHES_SYNC_SUCCESS',
    defaultMessage:
      'Changes are being synchronized in Impact. It may take up to 24 hours to appear.',
    description: 'Message to display when the sync was successfully triggered',
  },
  earnedSearchSyncError: {
    id: 'EARNED_SEARCHES_SYNC_ERROR',
    defaultMessage:
      'Whoops, changes have failed to be synchronized in Impact. Please, try again.',
    description:
      'Error to display when an error occurs triggering the sync process',
  },
  createImpactReportLabel: {
    id: 'ADVANCED_EARNED_SEARCH_CREATE_IMPACT_REPORT_LABEL',
    defaultMessage: 'Create Impact Report',
    description: 'caption for the create impact report label',
  },

  impactReportLabel: {
    id: 'ADVANCED_EARNED_SEARCH_IMPACT_REPORT_LABEL',
    defaultMessage: 'IMPACT REPORT',
    description: 'caption for the create impact report label',
  },

  savedAsImpactReportLabel: {
    id: 'ADVANCED_EARNED_SEARCH_SAVED_AS_IMPACT_REPORT_LABEL',
    defaultMessage: 'Saved as Earned Impact Report',
    description:
      'caption that indicates that a search was saves as an impact report',
  },
  syncChangesToImpactReportLabel: {
    id: 'ADVANCED_EARNED_SEARCH_SYNC_CHANGES_LABEL',
    defaultMessage: 'Sync Changes to Impact Report',
    description: 'caption for the sync impact report button',
  },

  lastSyncedLabel: {
    id: 'ADVANCED_EARNED_SEARCH_SAVED_LAST_SYNCED_LABEL',
    defaultMessage: 'Last Synced on {date}',
    description: 'caption for the last synced  impact report label',
  },

  lastSyncedTodayLabel: {
    id: 'ADVANCED_EARNED_SEARCH_SAVED_LAST_SYNCED_TODAY_LABEL',
    defaultMessage: 'Last Synced Today',
    description: 'caption for the last synced today impact report label',
  },
  successfullyUnArchivedSearch: {
    id: 'EARNED_SEARCH_BUILDER_SUCCESSFULLY_UNARCHIVE_SEARCH_MESSAGE',
    defaultMessage: 'Search was restored',
    description: 'Message when user unarchive any search',
  },
  filtersServiceSaveFail: {
    id: 'EARNED_SEARCH_EDITOR_FILTERS_SERVICE_FAILING',
    description:
      'Earned Searches  > Filters Bar : Filters could not be saved kite error message',
    defaultMessage: 'Filters could not be saved, please try again later.',
  },
  successfullyUnTrashCanSearch: {
    id: 'EARNED_SEARCH_BUILDER_SUCCESSFULLY_UNTRASHCAN_SEARCH_MESSAGE',
    defaultMessage: 'Search was restored',
    description: 'Message when user untrashcan any search',
  },
  advancedSearchTooltipLabel: {
    id: 'SECONDARY_HELP_TOOLTIP_ADVANCED_SEARCH',
    defaultMessage: 'Advanced Search Syntax Help',
    description: 'Message for Advanced Search Syntax Help',
  },
  simpleSearchTooltipLabel: {
    id: 'SECONDARY_HELP_TOOLTIP_SIMPLE_SEARCH',
    defaultMessage: 'Simple Search Help',
    description: 'Message for Simple Search Help',
  },
};
